import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { CountdownModule } from 'ngx-countdown';

import { initializeFeatureFlags } from './app/core/initializers/feature-flags.initializer';
import { MomentUtcDateAdapter } from './app/moment-utc-date-adapter';
import { initializeAuth } from './app/services/initializers/app.initializer';
import { UsersLogicService } from './app/services/logic-services';
import { FeatureFlagService } from './app/services/logic-services/feature-flag.service';
import { AppInsightsService } from './app/services/utility-services';
import { HeaderInterceptorService } from './core';
import { TokenInterceptorService } from './core/interceptors/token-interceptor.service';
import { environment } from './environments/environment';
import { MainComponent } from './main/main.component';
import { mainRoutes } from './main/main.routes';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(MainComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideAnimations(),
        importProvidersFrom(CountdownModule),
        provideRouter(mainRoutes),
        AppInsightsService,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        // Moves Material overlays (autocomplete panels, menus, dialogs) into the full-screen map so they stay visible.
        { provide: OverlayContainer, useClass: FullscreenOverlayContainer },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptorService, multi: true },
        provideAppInitializer(() => {
            initializeAuth(inject(UsersLogicService))();
        }),
        provideAppInitializer(() => {
            return initializeFeatureFlags(inject(FeatureFlagService))();
        }),
        provideAppInitializer(() => {
            inject(MatIconRegistry).setDefaultFontSetClass('material-symbols-outlined', 'mat-ligature-font');
        }),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
    ]
})
    .catch(err => {
        console.error(err);
    });
